import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import DataService from '../../services/data.service';
import AuthService from '../../services/auth.service';
import CaudalChart from './CaudalChart';
import PHChart from './PHChart';
import WeeklyChart from './WeeklyChart';

const Dashboard = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [dailyData, setDailyData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const isAdmin = AuthService.isAdmin();

  const fetchDailyData = () => {
    setLoading(true);
    setError('');
    DataService.getDailyData(selectedDate)
      .then(response => {
        setDailyData(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error al cargar los datos diarios');
        setLoading(false);
        console.error(err);
      });
  };

  const fetchWeeklyData = () => {
    DataService.getWeeklyData()
      .then(response => {
        setWeeklyData(response.data);
      })
      .catch(err => {
        console.error('Error al cargar los datos semanales:', err);
      });
  };

  useEffect(() => {
    fetchDailyData();
    fetchWeeklyData();
  }, []);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchDailyData();
  };

  return (
    <Container className="mt-4">
      <h2>Dashboard de Calidad del Agua</h2>
      
      <Card className="mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="align-items-center">
              <Col xs={12} md={6} lg={4}>
                <Form.Group>
                  <Form.Label>Seleccionar Fecha</Form.Label>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    max={new Date().toISOString().split('T')[0]}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={2} className="mt-md-4">
                <Button type="submit" variant="primary">
                  Consultar
                </Button>
              </Col>
              {isAdmin && (
                <Col xs={12} md={12} lg={6} className="mt-3 mt-lg-0 text-lg-end">
                  <Button variant="success" href="/upload">
                    Subir Nuevos Datos
                  </Button>
                </Col>
              )}
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="text-center my-5">
          <p>Cargando datos...</p>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : dailyData.length === 0 ? (
        <Alert variant="warning">
          No hay datos disponibles para la fecha seleccionada.
        </Alert>
      ) : (
        <>
          <Row>
            <Col md={6}>
              <CaudalChart data={dailyData} />
            </Col>
            <Col md={6}>
              <PHChart data={dailyData} />
            </Col>
          </Row>
          
          {weeklyData.length > 0 && (
            <Row>
              <Col>
                <WeeklyChart data={weeklyData} />
              </Col>
            </Row>
          )}
          
          <Card>
            <Card.Header as="h6">Datos Detallados</Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Hora</th>
                      <th>Caudal (m³/h)</th>
                      <th>pH</th>
                      <th>Color (UCV)</th>
                      <th>Turbiedad (NTU)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dailyData.map((item, index) => (
                      <tr key={index}>
                        <td>{new Date(item.fecha + 'T' + item.hora).toLocaleTimeString()}</td>
                        <td>{item.caudal.toFixed(2)}</td>
                        <td>{item.ph_cruda.toFixed(2)}</td>
                        <td>{item.color.toFixed(2)}</td>
                        <td>{item.turbiedad.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};

export default Dashboard;